module.exports = __webpack_public_path__ + "static/img/4-g.6f8c9f3d.png";